import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const NetworkIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.7494 10.9415C11.441 11.218 11.4151 11.6922 11.6915 12.0006C11.968 12.3091 12.4422 12.335 12.7506 12.0585C14.1307 10.8214 15 9.01195 15 7.00001C15 4.98806 14.1307 3.17864 12.7506 1.94154C12.4422 1.66506 11.968 1.69096 11.6915 1.99939C11.4151 2.30782 11.441 2.78199 11.7494 3.05847C12.8223 4.02021 13.5 5.42787 13.5 7.00001C13.5 8.57214 12.8223 9.9798 11.7494 10.9415Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.4707 8.96862C10.1773 9.26093 10.1763 9.7358 10.4686 10.0293C10.7609 10.3228 11.2358 10.3237 11.5293 10.0314C12.2882 9.27549 12.75 8.18873 12.75 7.00001C12.75 5.81129 12.2882 4.72452 11.5293 3.96862C11.2358 3.67631 10.7609 3.67726 10.4686 3.97074C10.1763 4.26421 10.1773 4.73909 10.4707 5.03139C10.9383 5.49707 11.25 6.19757 11.25 7.00001C11.25 7.80244 10.9383 8.50294 10.4707 8.96862Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.30847 1.9994C4.58495 2.30784 4.55905 2.782 4.25062 3.05849C3.17775 4.02022 2.5 5.42789 2.5 7.00002C2.5 8.57215 3.17775 9.97982 4.25062 10.9416C4.55905 11.218 4.58495 11.6922 4.30847 12.0006C4.03198 12.3091 3.55782 12.335 3.24938 12.0585C1.86933 10.8214 1 9.01197 1 7.00002C1 4.98808 1.86933 3.17865 3.24938 1.94156C3.55782 1.66507 4.03198 1.69097 4.30847 1.9994Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.53139 3.97075C5.8237 4.26423 5.82275 4.7391 5.52927 5.03141C5.06173 5.49708 4.75 6.19759 4.75 7.00002C4.75 7.80245 5.06173 8.50296 5.52927 8.96863C5.82275 9.26094 5.8237 9.73581 5.53139 10.0293C5.23908 10.3228 4.76421 10.3237 4.47073 10.0314C3.71181 9.27551 3.25 8.18874 3.25 7.00002C3.25 5.8113 3.71181 4.72453 4.47073 3.96863C4.76421 3.67633 5.23908 3.67727 5.53139 3.97075Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.75 8.85463C9.48296 8.55794 10 7.83936 10 7.00001C10 5.89544 9.10457 5.00001 8 5.00001C6.89543 5.00001 6 5.89544 6 7.00001C6 7.83936 6.51704 8.55794 7.25 8.85463V14.25C7.25 14.6642 7.58579 15 8 15C8.41421 15 8.75 14.6642 8.75 14.25V8.85463Z"
		></path>
	</svg>
))
